import { apiCall, getTenantId } from "@/core/api";

export async function getDataStorePlusUrl(): Promise<string | undefined> {
  const endpoint = "/data-store-plus/authenticated-url";

  try {
    const response = await apiCall("GET", endpoint);

    if (response && response.code === 200) {
      // Check multiple possible locations for the URL
      let url: string | undefined;

      if (response.result && response.result.length > 0) {
        // If result has content, use first element
        const firstUrl = response.result;
        url = firstUrl;
      } else if (response.message && typeof response.message === "string") {
        // If message contains the URL, use it
        url = response.message;
      } else if (response.result && typeof response.result === "string") {
        // If result itself is a string
        url = response.result;
      }

      if (url) {
        return url;
      }
      console.error("No valid Data Store + URL found in response");
      return undefined;
    }

    console.error(
      "Failed to fetch the authenticated Data Store + URL - Response code:",
      response?.code
    );
    return undefined;
  } catch (error) {
    console.error("Error in getDataStorePlusUrl:", error);
    return undefined;
  }
}

// Function to handle workspace deletion
export async function deleteDataStorePlusWorkspace(
  orgId: string
): Promise<any> {
  try {
    const tenantId = await getTenantId();

    if (!tenantId || !orgId) {
      throw new Error("Missing tenant ID or organization ID");
    }

    const endpoint = `/data-store-plus/workspace/${orgId}/${tenantId}`;
    const response = await apiCall("DELETE", endpoint);

    return response;
  } catch (error) {
    console.error("Error deleting workspace:", error);
    throw error;
  }
}
